/*
 * @Author: cc
 * @LastEditTime: 2026-09-22 16:14:42
 */
import { LeftOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { post } from "../../common/fetch";
import { HistoryPush, useQuery } from "../../common/utils";
import { VideoProps } from "../../reducers/video";
import "./play.scss";
// import like from "../../img/like.png";
// import cancalLike from "../../img/cancelLike.png";
import { FilePdfOutlined, YoutubeOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Space, Tooltip, message } from "antd";
import moment from "moment";
import { useHistory } from "react-router";
import { CCvideoControlInstance } from "../../common/video";
import { Icon } from "../../components/index";
import CCPlayer from "../../components/videoPlayer/CCPlayer";
import store from "../../reducers";
import Comment from "../comment/comment";
// import { watch, preventOpenMoreVideoFn } from "../../common/utils";

// 列表项类型接口定义
interface ListPropsType {
  id: number; // 唯一标识ID
  name: string; // 名称
  showName: string; // 显示名称
  videoWatchProgress: string; // 视频观看进度
  duration?: number; // PDF 需阅读时长（秒）
  durationText: string; // 时长文本
  type?: 2 | 4; // 类型 2:视频课件 4:pdf
}

// 视频信息属性接口定义
interface videoInfoProps {
  content: string; // 内容
  photo: string; // 照片
  name: string; // 名称
  title: string; // 标题
  institution: string; // 机构
}

// 章节列表属性接口定义
interface sectionListProps {
  courseName: string; // 课程名称
  courseContent: string; // 课程内容
  progress?: string; // 进度
  userPraiseFlag: boolean; // 用户点赞标志
  courseWatchTimeText?: string; // 课程观看时间文本
  list: ListPropsType[]; // 列表项数组
  hasExamFlag?: number; // 是否有考试标志
  hasQuestionnaireFlag?: number; // 是否有问卷标志
  examSystemType?: number; // 考试系统类型
  evaluateFormId?: number; // 评估表单ID
}

// （已移除水印逻辑）
const { TextArea } = Input;
let siteid: string;
const { REACT_APP_PDF_DOMAIN, REACT_APP_PDF_URL } = process.env;
// 默认讲师头像图片
const teacherDefaultAvator =
  "https://shiziimg.mvwchina.com/20200106/teacher/aZeZnG4rWtjtzYcmT2BZ.jpg";
window.ccPlayerStatus = null;
const toNumberOrEmpty = (value: any) => {
  if (value === "" || value === null || value === undefined) return value;
  const next = Number(value);
  return Number.isNaN(next) ? value : next;
};

const hasValue = (value: any) =>
  value !== "" &&
  value !== null &&
  value !== undefined &&
  value !== "undefined" &&
  value !== "null";

function Play(props: any) {
  const history = HistoryPush();
  const routeHistory = useHistory();
  const { setVideoStatus, videoInfo } = props;
  const [content, setContent] = useState("");
  // const [endTime, setEndTime] = useState<Date | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEvaluateDrawerVisible, setIsEvaluateDrawerVisible] = useState(false);
  const [eductionAiUrl, setEductionAiUrl] = useState<string>("");
  const {
    projectInfo: { projectName = "" },
  } = store.getState();
  // const livePlayerRef = useRef<any>();
  let [currentSectionInfo, setCurrentSectionInfo] = useState({
    type: "video",
    index: 0,
    sectionId: 0,
  });

  // 视频类型 1:cc 3:阿里云（当前仅使用 CC）
  const [videoSource, setVideoSource] = useState<"" | number>(1);
  const [ccConfig, setCcConfig] = useState<any>(null);
  const [videoTeacherInfoList, setVideoTeacherInfoList] =
    useState<videoInfoProps>({} as videoInfoProps);
  const [sectionList, setSectionList] = useState<sectionListProps>(
    {} as sectionListProps
  );
  const [livePlayer, setLivePlayer] = useState<any>(null);
  const [pdfRemainingSeconds, setPdfRemainingSeconds] = useState<number | null>(null);

  let query = useQuery();
  const topicId = query.get("topicId");
  const projectId = query.get("projectId");
  const courseId = query.get("courseId");
  const saleActivityId = query.get("saleActivityId");
  let sectionId = query.get("sectionId");
  const { hasQuestionnaireFlag, hasExamFlag, examSystemType } = sectionList;
  // 判断当前是否是点播课程
  const type = query.get("type");
  const isSaleActivityPlay = type === "saleActivity";
  // const isMySelf = type === "myself";
  const findCcUserIdByProjectIdMap = new Map([["1154", "AA247F3728571B49"]]); // 根据项目ID单独设置sitId
  //推荐课程查询
  const getSectionInfo = () => {
    let url = "";
    if (type === "saleActivity") {
      url = "/shop/front/marketing/project/section/Info";
    } else if (type === "topic") {
      url = "/shop/front/project/topic/section/Info";
    } else {
      url = `/shop/front/project/section/Info`;
    }
    post(
      url,
      {
        saleActivityId: saleActivityId ? Number(saleActivityId) : saleActivityId,
        projectId: projectId ? Number(projectId) : projectId,
        courseId: courseId ? Number(courseId) : courseId,
        sectionId: sectionId ? Number(sectionId) : sectionId,
        topicId: topicId ? Number(topicId) : topicId,
        videoType: "mySelf",
      },
      false
    ).then((res) => {
      const new_time = new Date().getTime() + "";
      setResultInfo({ ...res.data, videoUniqueCode: new_time });
    });
  };
  // 点播课程
  const getMyself = () => {
    post(
      `/shop/front/institute/course/learn`,
      {
        courseId,
      },
      false
    ).then((res) => {
      const new_time = new Date().getTime() + "";
      setResultInfo({ ...res.data, videoUniqueCode: new_time });
    });
  };
  // 公益课程
  const getPublic = () => {
    post(
      `/shop/front/myself/course/learn`,
      {
        courseId,
      },
      false
    ).then((res) => {
      const new_time = new Date().getTime() + "";
      setResultInfo({ ...res.data, videoUniqueCode: new_time });
    });
  };
  // 设置视频缓存数据
  const setResultInfo = (res: any) => {
    setVideoInfo(res);
  };
  // 设置视频参数等
  const setVideoInfo = (data: any) => {
    const { index } = currentSectionInfo;
    const {
      courseInfo,
      projectWatchRule,
      courseTeacherList,
      videoUniqueCode,
      courseGlobalRuleInfo,
    } = data;

    const {
      sectionList,
      courseName,
      courseWatchTimeText,
      progress,
      courseContent,
      userPraiseFlag,
      hasQuestionnaireFlag,
      examSystemType,
      hasExamFlag,
      evaluateFormId,
    } = courseInfo;
    const {
      videoUrl,
      videoWatchAt,
      courseId,
      videoWatchProgress,
      type,
      id,
      videoSource,
      videoWatchTime,
      ccUserId,
      duration,
    } = courseInfo.sectionList[index];
    siteid = findCcUserIdByProjectIdMap.get(projectId || "")
      ? (findCcUserIdByProjectIdMap.get(projectId || "") as string)
      : ccUserId; // 动态设置siteid（与移动端一致）
    if (type === 4) {
      setSectionList({
        courseName,
        evaluateFormId,
        userPraiseFlag: userPraiseFlag === 0 ? false : true,
        courseContent,
        list: sectionList,
      });
      setCurrentSectionInfo({
        ...currentSectionInfo,
        sectionId: id,
        type: "pdf",
      });
      setTimeout(() => {
        // livePlayerRef.current.src = getPdfUrlBySectionId(id);
        // livePlayerRef.current.style.width = "100%";
        setLivePlayer(getPdfUrlBySectionId(id));
      });
      return;
    }
    setCurrentSectionInfo({
      ...currentSectionInfo,
      type: "video",
    });
    let canDragFlag = 0;
    let fastForwardFlag = 0;
    // 是否允许拖拽
    let watchRule = projectWatchRule || courseGlobalRuleInfo;
    if (watchRule) {
      // 课程学满可拖动
      if (watchRule.canDragFlag === 3 && videoWatchProgress >= 100) {
        canDragFlag = 1;
      } else if (watchRule.canDragFlag === 2) {
        canDragFlag = 1;
      } else {
        canDragFlag = 0;
      }
      if (watchRule.fastForwardFlag === 3 && videoWatchProgress >= 100) {
        fastForwardFlag = 1;
      } else if (watchRule.fastForwardFlag === 2) {
        fastForwardFlag = 1;
      } else {
        fastForwardFlag = 0;
      }
    }

    setSectionList({
      userPraiseFlag: userPraiseFlag === 0 ? false : true,
      courseName,
      courseContent,
      courseWatchTimeText,
      progress,
      list: sectionList,
      hasQuestionnaireFlag,
      examSystemType,
      hasExamFlag,
      evaluateFormId,
    });
    // 获取讲师信息
    if (courseTeacherList && courseTeacherList[0]) {
      setVideoTeacherInfoList(courseTeacherList[0]);
    } else {
      setVideoTeacherInfoList({} as any);
    }
    setVideoStatus({
      type: "SET_VIDEO_STATUS",
      vid: videoUrl,
      siteid,
      videoUniqueCode,
      // CC 进度条始终可操作；是否允许向前跳转由 banDrag 控制
      progressbar_enable: 1,
      rate_allow_change: fastForwardFlag,
      watchStartTime: videoWatchAt,
      projectId: Number(projectId),
      courseId,
      forward: 0, //左右方向键控制快进退步长
      sectionId: id,
      videoType: query.get("type"),
      topicId,
      saleActivityId: saleActivityId ? Number(saleActivityId) : saleActivityId,
      //是否防挂机 0 不弹出 1.定时弹出 2.随机弹出
      preventOnHookFlag: projectWatchRule
        ? projectWatchRule.preventOnHookFlag
        : 0,
      // 弹出次数
      randomPopUpNum: projectWatchRule ? projectWatchRule.randomPopUpNum : 0,
      // 放挂机提示语
      onHookTipInfo: projectWatchRule
        ? projectWatchRule.onHookTipInfo
        : "辛苦，请继续观看！",
      // 防多开设置
      preventConcurrentPlayFlag: projectWatchRule
        ? projectWatchRule.preventConcurrentPlayFlag
        : 0,
      videoSource,
      videoDuration: duration,
    });
    // 使用 CCPlayer 组件化初始化（与移动端一致）
    setVideoSource(1);
    CCvideoControlInstance.pause();
    CCvideoControlInstance.reset();
    window.pauseTimer = null;
    console.log("[PC Play] Setting ccConfig:", {
      vid: videoUrl,
      siteid: String(siteid),
      canDrag: canDragFlag,
      watchStartTime: videoWatchProgress === "100" ? 0 : videoWatchTime,
      allowRateChange: fastForwardFlag,
      projectId,
      ccUserId,
      originalSiteid: siteid,
    });

    // 确保配置完整且有效，并延迟初始化以确保DOM准备就绪
    if (videoUrl && siteid) {
      const newConfig = {
        vid: videoUrl,
        siteid: String(siteid),
        canDrag: canDragFlag,
        watchStartTime: videoWatchProgress === "100" ? 0 : videoWatchTime,
        allowRateChange: fastForwardFlag,
        videoWaterMask: undefined, // 与移动端保持一致的参数结构
      };

      // 延迟设置配置，确保播放器容器已准备好
      setTimeout(() => {
        setCcConfig(newConfig);
        console.log("[PC Play] CCPlayer config set:", newConfig);
      }, 100);
    } else {
      console.error("[PC Play] Invalid video config - missing vid or siteid:", {
        videoUrl,
        siteid,
      });
    }
  };
  /**
   * 初始化阿里云
   * @param videoId
   */
  // 已移除阿里云初始化逻辑
  const chooseSetVideoFn = () => {
    if (
      ["myself", "ourHospital", "platformResource"].includes(type as string)
    ) {
      getMyself();
    } else if (type === "public") {
      getPublic();
    } else {
      getSectionInfo();
    }
  };
  const onChange = ({ target: { value } }: any) => {
    setContent(value);
  };
  const showModal = () => {
    setContent("");
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const addNotes = () => {
    const { sectionId } = videoInfo;
    let type;
    const paramType = query.get("type");
    if (paramType === "public") {
      type = 2;
    } else if (paramType === "myself" || paramType === "ourHospital") {
      type = 3;
    } else {
      type = 1;
    }
    let param = {
      courseId: Number(courseId),
      sectionId: Number(sectionId),
      type,
      content,
      projectId,
    };
    if (projectId) {
      param["projectId"] = projectId;
    }
    if (content) {
      if (content.length > 1000) {
        message.info("笔记最多为1000字");
        return;
      }
      const url = `/shop/front/addUserLearnNote`;
      post(url, param, false).then((res) => {
        message.info("提交成功");
        handleCancel();
      });
    } else {
      message.info("笔记不能为空");
    }
  };
  const getCourseQuestionnaireUrl = () => {
    if (hasQuestionnaireFlag !== 1) {
      return;
    }
    if (isSaleActivityPlay) {
      const params: any = {
        saleActivityId: saleActivityId ? toNumberOrEmpty(saleActivityId) : saleActivityId,
        projectId: projectId ? toNumberOrEmpty(projectId) : projectId,
        courseId: courseId ? toNumberOrEmpty(courseId) : courseId,
      };
      const requestUrl = hasValue(topicId)
        ? "/shop/front/marketing/getProjectTopicCourseStarQuestionnaireUrl"
        : "/shop/front/marketing/getProjectCourseStarQuestionnaireUrl";
      if (hasValue(topicId)) {
        params.topicId = toNumberOrEmpty(topicId);
      }
      post(requestUrl, params, true).then((res) => {
        const questionnaireUrl = res.data?.questionnaireUrl;
        if (questionnaireUrl) {
          window.location.href = questionnaireUrl;
        }
      });
      return;
    }
    post(
      `/shop/questionnaire/getCourseStarQuestionnaireUrl/${courseId}`,
      {},
      true
    ).then((res) => {
      const { questionnaireUrl } = res.data;
      window.location.href = questionnaireUrl;
    });
  };
  const getExamUrl = () => {
    if (hasExamFlag !== 1) {
      return;
    }
    if (isSaleActivityPlay) {
      getSaleActivityCourseExamUrl();
      return;
    }
    examSystemType === 1 ? getExamType4Url() : getExamType5Url();
  };
  const getSaleActivityCourseExamUrl = () => {
    const params: any = {
      saleActivityId: saleActivityId ? toNumberOrEmpty(saleActivityId) : saleActivityId,
      projectId: projectId ? toNumberOrEmpty(projectId) : projectId,
      courseId: courseId ? toNumberOrEmpty(courseId) : courseId,
    };
    const requestUrl = hasValue(topicId)
      ? "/shop/front/marketing/exam/checkProjectTopicCourseExam"
      : "/shop/front/marketing/exam/checkProjectCourseExam";
    if (hasValue(topicId)) {
      params.topicId = toNumberOrEmpty(topicId);
    }
    post(requestUrl, params, true).then((res) => {
      const data = res.data || {};
      if (data.courseCanExamNum === 0 && data.courseExamLimitFlag === 1) {
        return;
      }
      const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
      window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityCourseExam&projectId=${projectId}&saleActivityId=${saleActivityId}&courseId=${courseId}${
        hasValue(topicId) ? `&topicId=${topicId}` : ""
      }`;
    });
  };
  // 获取4.0课程考试链接
  const getExamType4Url = () => {
    post(`/shop/exam/getCourseExamUrl/${courseId}`, {}, true).then((res) => {
      const { courseExamUrl } = res.data;
      window.location.href = courseExamUrl;
    });
  };
  // 获取5.0课程考试链接
  const getExamType5Url = () => {
    post(`/shop/exam/getCourseExamPaperInfo`, { courseId }, true).then(
      (res) => {
        const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
        window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=courseExamForC&&courseId=${courseId}`;
      }
    );
  };
  /**
   * 切换视频
   * @param item
   * @param index
   */
  window.video_end = function () {
    let { index } = currentSectionInfo;
    const item = (sectionList.list as any)[index + 1];
    if (item && item.type === 2) {
      checkoutVideo(item, index + 1);
    } else {
      return;
    }
  };
  const setStartTime = (id?: number) => {
    let data = {
      time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      sectionId: id || currentSectionInfo.sectionId,
      type: currentSectionInfo.type,
    };
    sessionStorage.setItem("currentSection", JSON.stringify(data));
  };
  const durationRecordFn = () => {
    let currentSection = JSON.parse(
      sessionStorage.getItem("currentSection") || ""
    );
    let typeText = query.get("type");
    if (currentSection.type === "pdf") {
      const data: any = {
        watchBeginTimeText: currentSection.time,
        watchEndTimeText: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        projectId: projectId ? toNumberOrEmpty(projectId) : null,
        courseId: courseId ? toNumberOrEmpty(courseId) : courseId,
        sectionId: currentSection.sectionId ? toNumberOrEmpty(currentSection.sectionId) : null,
      };
      if (hasValue(topicId)) {
        data.topicId = toNumberOrEmpty(topicId);
      }
      let url = "";
      if (typeText === "saleActivity") {
        url = "/shop/front/marketing/project/pdf/watch/record/save";
        Object.assign(data, { saleActivityId: saleActivityId ? toNumberOrEmpty(saleActivityId) : saleActivityId });
      } else if (typeText === "ourHospital") {
        url = "/shop/course/pdf/watch/record/save";
      } else if (typeText === "platformResource") {
        url = "/shop/commodity/course/pdf/watch/record/save";
      } else {
        url = "/shop/project/pdf/watch/record/save";
      }
      post(url, { ...data }, false);
    }
  };
  // 监听ccConfig变化，确保播放器正确初始化
  useEffect(() => {
    if (ccConfig && ccConfig.vid && ccConfig.siteid) {
      console.log(
        "[PC Play] CCConfig updated, player should initialize:",
        ccConfig
      );
    }
  }, [ccConfig]);

  useEffect(() => {
    chooseSetVideoFn();
    return () => {
      try {
        let currentSection = JSON.parse(
          sessionStorage.getItem("currentSection") || ""
        );
        console.log("currentSection", currentSection);

        if (currentSection && (currentSection as any).type === "pdf") {
          durationRecordFn();
          sessionStorage.removeItem("currentSection");
        }
      } catch (error) {
        console.log("error", error);
      }
      window.ccPlayerStatus && window.ccPlayerStatus.destroy();
      window.ccPlayerStatus = null;
      window.video_end = null;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (currentSectionInfo.type === "pdf") {
      console.log(currentSectionInfo);
      setStartTime(currentSectionInfo.sectionId);
    }
    // setStartTime 为组件内定义的稳定函数，不作为依赖
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSectionInfo]);

  const currentPdfSection = sectionList.list?.find((item) => item.id === currentSectionInfo.sectionId);
  const pdfDuration = currentSectionInfo.type === "pdf" ? Number(currentPdfSection?.duration) : 0;
  useEffect(() => {
    if (!Number.isFinite(pdfDuration) || pdfDuration <= 0) {
      setPdfRemainingSeconds(null);
      return;
    }

    const endTime = Date.now() + pdfDuration * 1000;
    setPdfRemainingSeconds(Math.ceil(pdfDuration));
    const timer = window.setInterval(() => {
      const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setPdfRemainingSeconds(remaining);
      if (remaining === 0) window.clearInterval(timer);
    }, 1000);
    return () => window.clearInterval(timer);
  }, [currentSectionInfo.sectionId, pdfDuration]);

  /**
   * 切换视频或者pdf
   * @param item
   * @param index
   */
  const checkoutVideo = (item: ListPropsType, index: number) => {
    const { type, id } = item;
    if (sessionStorage.getItem("currentSection")) {
      let currentSection = JSON.parse(
        sessionStorage.getItem("currentSection") || ""
      );
      if (currentSection && (currentSection as any).type === "pdf") {
        durationRecordFn();
      }
    }
    currentSectionInfo = {
      index,
      type: type === 2 ? "video" : "pdf",
      sectionId: id,
    };
    //如果当前是视频
    if (type === 2) {
      // 切换页面调用watch(3)进行暂停记录
      (window as any)["playing"] && CCvideoControlInstance.watch(3);

      window.ccPlayerStatus && window.ccPlayerStatus.destroy();
      window.ccPlayerStatus = null;
      setCurrentSectionInfo({ ...currentSectionInfo });
      chooseSetVideoFn();
    } else {
      setStartTime(id);
      setCurrentSectionInfo({
        ...currentSectionInfo,
      });

      setTimeout(() => {
        // livePlayerRef.current.src = getPdfUrlBySectionId(id);
        // livePlayerRef.current.style.width = "100%";
        setLivePlayer(getPdfUrlBySectionId(id));
      });
    }
  };
  /**
   * 获取pdf地址
   * @param id
   */
  const getPdfUrlBySectionId = (id: number) => {
    return `${REACT_APP_PDF_DOMAIN}/static/common/pdfjs/generic/web/viewer.html?file=${REACT_APP_PDF_URL}/shop/section/file/preview/${id}`;
  };

  const getCurrentVideoProgress = (): number => {
    try {
      const duration = Number(window.ccPlayerStatus?.getDuration?.());
      const position = Number(window.ccPlayerStatus?.getPosition?.());
      if (Number.isFinite(duration) && duration > 0 && Number.isFinite(position) && position >= 0) {
        return Math.min((position / duration) * 100, 100);
      }
    } catch {
      // 播放器尚未就绪时使用接口返回的最近一次学习进度。
    }

    const currentSection = sectionList.list?.find((item) => item.id === currentSectionInfo.sectionId)
      || sectionList.list?.[currentSectionInfo.index];
    const progress = Number(currentSection?.videoWatchProgress);
    return Number.isFinite(progress) ? progress : 0;
  };

  const onCommentClickHandle = () => {
    setIsEvaluateDrawerVisible(true);
  };

  const getCookie = (name: string) => {
    const cookie = document.cookie;
    const cookieArray = cookie.split(";");
    const cookieObj: any = {};
    cookieArray.forEach((item) => {
      const [key, value] = item.split("=");
      cookieObj[key] = value;
    });
    console.log("cookieObj", cookieObj[name]);
    return cookieObj[name];
  };
  /**
   * 跳转毕教智能体
   */
  const jumpEduAI = () => {
    const caId = getCookie(" X-MVW-userID");
    const token = getCookie(" access-key");
    const url = `https://ai.mvwchina.com/unify/chat?urlKey=6yOUiKcXLBJWuT4j&caId=${caId}&token=${token}&notShowBack=0`;
    setEductionAiUrl(url);
  };

  // 移除重复的useEffect，只保留第一个
  return (
    <>
      <div className="video_title">
        <p
          className="left"
          onClick={() => {
            routeHistory.go(-1);
          }}
        >
          <LeftOutlined />
          &emsp;<p>{sectionList.courseName}</p>
        </p>
        {!isSaleActivityPlay && (
          <p
            style={{ fontSize: "20px" }}
            onClick={() => {
              history.push("/personal");
            }}
          >
            个人中心
          </p>
        )}
      </div>
      <div className="playInfo_box">
        {currentSectionInfo.type === "video" && (
          <>
            {videoSource === 1 && ccConfig ? (
              <CCPlayer cc={ccConfig} height={`calc(100vh - 58px)`} />
            ) : (
              <div
                style={{
                  height: `calc(100vh - 58px)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#000",
                  color: "#fff",
                }}
              >
                {ccConfig ? "播放器加载中..." : "视频配置加载中..."}
              </div>
            )}
          </>
        )}
        {currentSectionInfo.type === "pdf" && (
          <iframe
            // src=""
            scrolling="false"
            // ref={livePlayerRef}
            src={livePlayer}
            title="pdf"
            // key={Math.random()}
          ></iframe>
        )}
        <div className="video_info">
          {currentSectionInfo.type === "pdf" && pdfRemainingSeconds !== null && (
            <div className="pdf-reading-countdown" role="status" aria-live="off">
              PDF阅读剩余时间 {pdfRemainingSeconds} 秒
            </div>
          )}
          <div style={{ paddingBottom: "60px", overflowY: "scroll" }}>
            <div
              className="project_name_box"
              style={{
                background: "#999999",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "16px",
                color: "#fff",
                height: "42px",
                lineHeight: "42px",
              }}
            >
              {/* <h6>{sectionList.courseName}</h6>
              <img
                src={sectionList.userPraiseFlag ? like : cancalLike}
                alt="点赞"
                className="live_style"
                onClick={saveUserPraiseInfo}
              /> */}
              课件列表
              {sectionList.progress && (
                <span
                  style={{ marginLeft: "20px" }}
                  className="refresh_box"
                  onClick={() => {
                    chooseSetVideoFn();
                  }}
                >
                  <Space>
                    <Icon icon="circle-notch" />
                    <a style={{ color: "#fff", fontSize: "14px" }}>刷新进度</a>
                  </Space>
                </span>
              )}
            </div>

            <p className="show-info">
              {sectionList.list &&
                (sectionList.list as any).map((item: any, index: number) => (
                  <div
                    onClick={() => {
                      checkoutVideo(item, index);
                    }}
                    style={{
                      marginTop: "10px",
                      cursor: "pointer",
                      wordBreak: "break-all",
                      width: "100%",
                    }}
                  >
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {item.type === 2 && (
                          <YoutubeOutlined style={{ fontSize: "14px" }} />
                        )}
                        {item.type === 4 && (
                          <FilePdfOutlined style={{ fontSize: "14px" }} />
                        )}
                        <Tooltip placement="topLeft" title={item.name}>
                          <span
                            className={
                              currentSectionInfo.index === index ? "check" : ""
                            }
                            style={{
                              fontSize: "14px",
                              marginLeft: "10px",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {item.name}
                          </span>
                        </Tooltip>
                      </div>
                      {item.type === 2 && (
                        <Space>
                          <span>
                            {item.durationText}·
                            {item.videoWatchProgress === "100"
                              ? "已学完"
                              : `已学习${item.videoWatchProgress}%`}
                          </span>
                        </Space>
                      )}
                    </>
                  </div>
                ))}
            </p>

            {!isSaleActivityPlay && (
              <>
                <div>
                  <div>
                    <div
                      style={{
                        background: "#999999",
                        color: "#fff",
                        fontSize: "16px",
                        height: "42px",
                        lineHeight: "42px",
                        padding: "0 10px",
                      }}
                    >
                      讲师介绍
                    </div>
                    {videoTeacherInfoList.photo && (
                      <div className="teacher_info">
                        <div>
                          <img
                            style={{
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                            }}
                            src={
                              videoTeacherInfoList.photo ===
                              "https://mvw-shiziimg.oss-cn-beijing.aliyuncs.com"
                                ? teacherDefaultAvator
                                : videoTeacherInfoList.photo
                            }
                            alt=""
                          />
                        </div>
                        <div style={{ marginLeft: "20px", fontSize: "16px" }}>
                          <div>{videoTeacherInfoList.name}</div>
                          <div>{videoTeacherInfoList.title}</div>
                        </div>
                      </div>
                    )}
                    <div style={{ padding: "10px 8px" }}>
                      <div
                        className="teacher_detail"
                        dangerouslySetInnerHTML={{
                          __html: videoTeacherInfoList.content
                            ? videoTeacherInfoList.content
                            : "<div style='text-align:center;font-size:14px'>本课程暂无讲师介绍</div>",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      background: "#999999",
                      color: "#fff",
                      fontSize: "16px",
                      height: "42px",
                      lineHeight: "42px",
                      padding: "0 10px",
                    }}
                  >
                    课程介绍
                  </div>
                  <div
                    style={{ paddingLeft: "10px" }}
                    dangerouslySetInnerHTML={{
                      __html: sectionList.courseContent,
                    }}
                  ></div>
                </div>
              </>
            )}
          </div>

          <ul
            style={{
              position: "absolute",
              bottom: "0",
              left: 0,
              width: "100%",
            }}
          >
            {!isSaleActivityPlay && <li onClick={showModal}>记笔记</li>}
            {!isSaleActivityPlay && projectName.includes("师资培训") && (
              <li onClick={jumpEduAI}>毕教智能体</li>
            )}
            {!isSaleActivityPlay && sectionList.evaluateFormId ? (
              <li onClick={onCommentClickHandle}>测评</li>
            ) : null}
            {!["project"].includes(type as string) && (
              <li onClick={getCourseQuestionnaireUrl}>
                {hasQuestionnaireFlag !== 1 ? "无评价" : "课程评价"}
              </li>
            )}
            {!["project"].includes(type as string) && (
              <li onClick={getExamUrl}>
                {hasExamFlag !== 1 ? "无练习" : "课程练习"}
              </li>
            )}
          </ul>
        </div>
      </div>
      <Modal
        title="笔记"
        footer={null}
        closable={true}
        visible={isModalVisible}
        className="notesModal"
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TextArea
          value={content}
          placeholder=""
          onChange={onChange}
          showCount
          maxLength={1000}
          autoSize={true}
          className="notes_modal"
          style={{ height: 300 }}
        />
        <div style={{ textAlign: "right", padding: "40px 0 20px" }}>
          <Button
            type="primary"
            onClick={() => {
              addNotes();
            }}
            style={{ cursor: "pointer" }}
          >
            提交
          </Button>
        </div>
      </Modal>
      <Drawer
        title="测评"
        placement="right"
        open={isEvaluateDrawerVisible}
        onClose={() => setIsEvaluateDrawerVisible(false)}
        width="22vw"
        mask={false}
        className="evaluateDrawer"
      >
        <Comment
          courseId={courseId}
          evaluateFormId={sectionList.evaluateFormId ? String(sectionList.evaluateFormId) : null}
          projectId={projectId}
          topicId={topicId}
          getVideoProgress={getCurrentVideoProgress}
          getStudyProgress={() => Number(sectionList.progress)}
        />
      </Drawer>
      <Drawer
        title="毕教智能体"
        placement="right"
        onClose={() => {
          setEductionAiUrl("");
        }}
        open={!!eductionAiUrl}
        width={"20%"}
      >
        <iframe
          src={eductionAiUrl}
          title="毕教智能体"
          style={{ width: "100%", height: "100%" }}
        ></iframe>
      </Drawer>
    </>
  );
}
const getNavStatus = (state: {
  videoStatus: VideoProps;
  projectType: { type: number; activityId?: string };
}) => {
  return {
    videoInfo: state.videoStatus,
    projectType: state.projectType,
  };
};

const playFnProps = (dispatch: any) => {
  return {
    setVideoStatus: (param: VideoProps) => {
      dispatch({ ...param });
    },
  };
};
export default connect(getNavStatus, playFnProps)(Play);
